export const saveSearchInitializer = saveSearchService => {
	'ngInject';
	return {
		restrict: 'A',
		priority: 1000, // to ensure that the postLink run last.
		link: function postLink(scope, element, attrs) {
			window.ipEventBus.subscribe(
				'open-save-search-form',
				(channel, model) => {
					saveSearchService.openSaveSearch(model);
				},
				true
			);
		}
	};
};
